import { HIDE_RESOURCE_BY_SECONDARY_SEGMENT } from '@/layouts/admin/sidebar-config'
import { isResourceHiddenForSegment } from '@/layouts/admin/segment-labels'
import { usePermission } from '@/lib/hooks/use-permission'
import { useAuth } from '@/store/hooks'

/**
 * Se um recurso aparece para o usuário logado, com a MESMA regra do menu lateral
 * (`admin-sidebar.tsx`): recurso no plano, leitura na role e recurso não escondido
 * pelo segmento. Telas que oferecem algo de outro recurso (aba, seletor, opção)
 * devem perguntar aqui, e não só à própria permissão.
 */
export function useResourceVisibility() {
    const { user } = useAuth()
    const { canRead } = usePermission()
    const segment = user?.company?.segment || 'OTHER'
    const secondarySegment = user?.company?.secondarySegment || 'OTHER'

    return (module: string, resource: string): boolean => {
        if (
            HIDE_RESOURCE_BY_SECONDARY_SEGMENT[secondarySegment]?.includes(
                resource
            )
        )
            return false
        if (isResourceHiddenForSegment(segment, resource)) return false
        return canRead(module, resource)
    }
}

/**
 * Entidades de Gestão de entidades que outras telas oferecem para escolher. Sem o
 * recurso, a busca do seletor responde 403 — o campo não serve para nada e só
 * confunde.
 */
export function useEntityAccess() {
    const isResourceVisible = useResourceVisibility()
    return {
        canSeeProfessionals: isResourceVisible('person', 'professionals'),
        canSeePartners: isResourceVisible('person', 'partners'),
    }
}
